import React from 'react';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
} from '@mui/material';
import Loader from '../../../common/Loader';

// FORMATTED MESSAGES
import CustomersFormattedMessages from '../../../../messages/admin/CustomersFormattedMessages';

const CommentsTable = (props) => {
  let { list, loading } = props;

  if (loading) {
    return <Loader />;
  }

  return (
    <TableContainer>
      <Table size="small" sx={{ whiteSpace: 'nowrap' }}>
        <TableHead>
          <TableRow>
            <TableCell>{CustomersFormattedMessages.createdDate}</TableCell>
            <TableCell>{CustomersFormattedMessages.contactName}</TableCell>
            <TableCell colSpan="4">
              {CustomersFormattedMessages.comments}
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{list}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default CommentsTable;
